"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLuminance = void 0;
var _color2 = require("@cbhq/d3/color");
/**
 * Relative luminance is the relative brightness of any point in a colorspace, normalized to 0 for darkest black and 1 for lightest white.
 * https://contrastchecker.online/color-relative-luminance-calculator
 */
const getLuminance = value => {
  var _color;
  const rgbObject = (_color = (0, _color2.color)(value)) === null || _color === void 0 ? void 0 : _color.rgb();
  if (rgbObject) {
    const r = rgbObject.r,
      g = rgbObject.g,
      b = rgbObject.b;
    const red = Number.isNaN(r) ? 0 : r;
    const green = Number.isNaN(g) ? 0 : g;
    const blue = Number.isNaN(b) ? 0 : b;
    const _map = [red / 255, green / 255, blue / 255].map(item => item <= 0.04045 ? item / 12.92 : ((item + 0.055) / 1.055) ** 2.4),
      redLinear = _map[0],
      greenLinear = _map[1],
      blueLinear = _map[2];
    return 0.2126 * redLinear + 0.7152 * greenLinear + 0.0722 * blueLinear;
  }
  return undefined;
};
exports.getLuminance = getLuminance;